<template>
  <div class="row">
    <div class="col-md-6 mb-3" v-if="showRelationshipType">
      <label class="form-label required">Relationship</label>
      <multiselect
        v-model="selectedRelationshipType"
        :options="relationshipTypes"
        :searchable="true"
        :close-on-select="true"
        :show-labels="false"
        track-by="id"
        label="name"
        placeholder="Select Relationship"
        @input="emitRelationshipUpdate"
      >
        <template slot="singleLabel" slot-scope="{ option }">
          {{ option.name }}
        </template>
        <template slot="option" slot-scope="{ option }">
          <div>
            <strong>{{ option.name }}</strong>
            <div style="font-size: 0.85em; color: #666;">{{ option.description }}</div>
          </div>
        </template>
      </multiselect>
    </div>

    <div class="col-md-6 mb-3">
      <label class="form-label required">First Name</label>
      <input
        autocomplete="no_value"
        type="text"
        class="form-control"
        id="patientFirstName"
        v-model="customer.firstName"
        required="required"
        placeholder="Enter first name"
        @input="emitUpdate"
      />
      <div class="invalid-feedback">
        Please enter first name.
      </div>
    </div>

    <div class="col-md-6 mb-3">
      <label class="form-label">Last Name</label>
      <input
        autocomplete="no_value"
        type="text"
        class="form-control"
        id="patientLastName"
        v-model="customer.lastName"
        placeholder="Enter last name"
        @input="emitUpdate"
      />
      <div class="invalid-feedback">
        Please enter last name.
      </div>
    </div>

    <div class="col-md-6 mb-3" v-if="showIdNumber">
      <label class="form-label">ID Number</label>
      <input
        autocomplete="no_value"
        type="text"
        class="form-control"
        id="patientIdNumber"
        v-model="customer.idNumber"
        placeholder="Enter ID number"
        @input="emitUpdate"
      />
      <div class="invalid-feedback">
        Please enter id number.
      </div>
    </div>

    <div class="col-md-6 mb-3" v-if="showGender">
      <label class="form-label">Gender</label>
      <multiselect
        v-model="customer.gender"
        :options="genders"
        :searchable="false"
        :close-on-select="true"
        :show-labels="false"
        placeholder="Select Gender"
        @input="emitUpdate"
      >
      </multiselect>
      <div class="invalid-feedback">
        Please select gender.
      </div>
    </div>

    <div class="col-md-6 mb-3" v-if="showDateOfBirth">
      <label class="form-label">Date Of Birth</label>
      <date-picker
        v-model="customer.dateOfBirth"
        style="width: 100%"
        valueType="format"
        type="date"
        input-class="form-control"
        placeholder="Select date"
        @change="emitUpdate"
      ></date-picker>
      <div class="invalid-feedback">
        Please enter date of birth.
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";

export default {
  name: 'BasicDetailsSection',
  components: {
    DatePicker,
    Multiselect
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    showIdNumber: {
      type: Boolean,
      default: false
    },
    showGender: {
      type: Boolean,
      default: false
    },
    showDateOfBirth: {
      type: Boolean,
      default: false
    },
    showRelationshipType: {
      type: Boolean,
      default: false
    },
    relationshipTypes: {
      type: Array,
      default: () => []
    },
    selectedRelationship: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      customer: {},
      genders: ["MALE", "FEMALE", "OTHER"],
      selectedRelationshipType: null
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.customer = newVal;
      },
      deep: true
    },
    selectedRelationship: {
      immediate: true,
      handler(newVal) {
        this.selectedRelationshipType = newVal;
      }
    }
  },
  methods: {
    emitUpdate() {
      this.$emit('input', this.customer);
    },
    emitRelationshipUpdate() {
      this.$emit('relationship-change', this.selectedRelationshipType);
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/ContactDetails/sections/BasicDetailsSection.vue